import cristinaC from '../assets/staff/cristina-capitani.webp';
import ClaudioB from '../assets/staff/claudio-boso.webp';
import SamuelB from '../assets/staff/samuel-boso.webp';
import MattiaB from '../assets/staff/mattia-boso.webp';
import BusinessManager from '../components/BusinessManager';
import Backoffice from '../components/Backoffice';
import DivisionePrivateStaff from './DivisionePrivateStaff';
  
  export default function Staff() {
    return (
        <>
        <div className='mx-auto my-20 container'>
            <div className='flex justify-center items-center bg-black z-40'>
                <div className="mx-auto w-[90%]">
                    <div className="me-auto max-w-2xl text-start ml-4 md:ml-0">
                        <h2 className="text-3xl font-bold tracking-tight text-neutral-50 sm:text-4xl">Direzione</h2>
                        {/* <p className="mt-6 text-lg leading-8 text-neutral-400">
                        We’re a dynamic group of individuals who are passionate about what we do and dedicated to delivering the
                        best results for our clients.
                        </p> */}
                    </div>
                    <ul
                        role="list"
                        className="mx-auto mt-20 grid max-w-2xl grid-cols-2 gap-x-8 gap-y-16 text-center sm:grid-cols-3 md:grid-cols-4 lg:mx-0 lg:max-w-none lg:grid-cols-5 xl:grid-cols-6"
                    >
                        <li 
                        data-aos="fade-in" data-aos-duration="1500" 
                        >
                            <img className="mx-auto h-24 w-24 rounded-full" src={ClaudioB} alt="Claudio Boso"/>
                            <h3 className="mt-6 text-base font-semibold leading-7 tracking-tight text-neutral-200">Claudio Boso</h3>
                            <p className="text-sm leading-6 text-neutral-400">Presidente</p>
                        </li>
                        <li 
                        data-aos="fade-in" data-aos-duration="1500"
                        >
                            <img className="mx-auto h-24 w-24 rounded-full" src={cristinaC} alt="Cristina Capitani"/>
                            <h3 className="mt-6 text-base font-semibold leading-7 tracking-tight text-neutral-200">Cristina Capitani</h3>
                            <p className="text-sm leading-6 text-neutral-400">Legale Rappresentante</p>
                        </li>
                        <li 
                        data-aos="fade-in" data-aos-duration="1500" 
                        >
                            <img className="mx-auto h-24 w-24 rounded-full" src={SamuelB} alt="Samuel Boso"/>
                            <h3 className="mt-6 text-base font-semibold leading-7 tracking-tight text-neutral-200">Samuel Boso</h3>
                            <p className="text-sm leading-6 text-neutral-400">Membro del CdA</p>
                        </li>
                        <li 
                        data-aos="fade-in" data-aos-duration="1500" 
                        >
                            <img className="mx-auto h-24 w-24 rounded-full" src={MattiaB} alt="Mattia Boso"/>
                            <h3 className="mt-6 text-base font-semibold leading-7 tracking-tight text-neutral-200">Mattia Boso</h3>
                            <p className="text-sm leading-6 text-neutral-400">Membro del CdA</p>
                        </li>
                    </ul>
                    <div className="me-auto max-w-2xl text-start mt-20 ml-4 md:ml-0">
                        <h2 className="text-3xl font-bold tracking-tight text-neutral-50 sm:text-4xl">Business Managers</h2>
                        {/* <p className="mt-6 text-lg leading-8 text-neutral-400">
                        We’re a dynamic group of individuals who are passionate about what we do and dedicated to delivering the
                        best results for our clients.
                        </p> */}
                    </div>
                    <BusinessManager/>
                    <div className="me-auto max-w-2xl text-start mt-20">
                        <h2 className="text-3xl font-bold tracking-tight text-neutral-50 sm:text-4xl">Divisione Private</h2>
                        {/* <p className="mt-6 text-lg leading-8 text-neutral-400">
                        We’re a dynamic group of individuals who are passionate about what we do and dedicated to delivering the
                        best results for our clients.
                        </p> */}
                    </div>
                    <DivisionePrivateStaff/>
                    <div className="me-auto max-w-2xl text-start mt-20 ml-4 md:ml-0">
                        <h2 className="text-3xl font-bold tracking-tight text-neutral-50 sm:text-4xl">Back office</h2>
                        {/* <p className="mt-6 text-lg leading-8 text-neutral-400">
                        We’re a dynamic group of individuals who are passionate about what we do and dedicated to delivering the
                        best results for our clients.
                        </p> */}
                    </div>
                    <Backoffice/>
                </div>
            </div>
        </div>
        </>
    )
  }
  